import React from "react";
import { Tabs as MantineTabs } from "@mantine/core";
import styled, { css } from "styled-components";
const StyledTab = styled(MantineTabs.Tab)`
  height: 40px;
`;
const StyledPanel = styled(MantineTabs.Panel)(
  ({ theme }) => css`
    padding: ${theme.spacings.sm};
  `
);
const Tabs = ({
  children = void 0,
  defaultValue = void 0,
  value = void 0,
  onChange = void 0,
  variant = "outline",
  className = void 0,
  keepMounted = void 0
}) => /* @__PURE__ */ React.createElement(
  MantineTabs,
  {
    defaultValue,
    value,
    onChange,
    variant,
    className,
    keepMounted
  },
  children
);
Tabs.List = MantineTabs.List;
Tabs.Tab = StyledTab;
Tabs.Panel = StyledPanel;
export default Tabs;
